/**
 * description:
 * "Mingle Week" schedule: one card per event.
 * Each card has a date, time, room, event name, and description.
 */
import { Box, Typography } from "@mui/material";
import { mustard } from "../../../styles.tsx";

const shadowColors = ["#ad5d4e", mustard];

const events = [
  { date: "09/21", event: "Arts & Crafts", time: "7-9 PM", room: "SURGE 108A", description: "Show off your creative side by crafting up bracelets, painting, sculpting & more! " },
  { date: "09/22", event: "Speed Dating", time: "7-9 PM", room: "NCB 260", description: "Bring your energy and a bottle of water to come meet your potential matches! (Bigs arrive at 6:45)", required: true },
  { date: "09/23", event: "D7 Field Day", time: "7-9 PM", room: "Drillfield", description: "Catch a glimpse of D7 games on the Drillfield!" },
  { date: "09/24", event: "Game Night", time: "7-9 PM", room: "Robeson 105/112", description: "Let your competitive side shine with a night of exciting games alongside your possible big/little!" },
  { date: "09/25", event: "Bonfire", time: "6-9 PM", room: "Caldwell Fields", description: "Roast marshmallows and make memories with new and old friends around the bonfire! (Fill out the rideshare form on the links page!)" },
];

const MingleWeekTimeline = () => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(5, 1fr)" },
        gap: { xs: "16px", sm: "20px", md: "32px" },
      }}
    >
      {events.map((item, i) => (
        <Box
          key={item.event}
          sx={{
            bgcolor: "background.paper",
            borderRadius: "4px",
            p: "20px",
            boxShadow: `6px 6px 0 ${shadowColors[i % 2]}`,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", flexWrap: "nowrap", gap: "4px", mb: "10px" }}>
            <Typography sx={{ fontFamily: "Anton, sans-serif", textTransform: "uppercase", letterSpacing: "1px", fontSize: "1.05rem", color: "primary.main", whiteSpace: "nowrap" }}>
              {item.date}
            </Typography>
            <Typography
              sx={{
                fontStyle: "italic",
                fontSize: "0.62rem",
                color: "primary.main",
                opacity: 0.75,
                whiteSpace: "nowrap",
              }}
            >
              {item.time} · {item.room}
            </Typography>
          </Box>

          <Box sx={{ borderTop: "1px dashed rgba(18, 32, 31, 0.3)", mb: "12px" }} />

          <Typography variant="body1" sx={{ fontWeight: 700, color: "primary.main", fontSize: "1.1rem", mb: "4px" }}>
            {item.event}
          </Typography>

          {item.required && (
            <Typography
              sx={{
                fontWeight: 700,
                fontStyle: "italic",
                fontSize: "0.75rem",
                color: "secondary.main",
                whiteSpace: "nowrap",
                mb: "4px",
              }}
            >
              ★ Required for everyone!
            </Typography>
          )}

          <Typography variant="body2" sx={{ color: "#2b2b2b" }}>
            {item.description}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default MingleWeekTimeline;
